var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLineBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 244,
    height: 50,
    viewBox: "0 0 244 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#00b900;}.b,.c{fill:#fff;}.b{font-size:18px;font-family:Kanit-Medium, Kanit;font-weight:500;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 244,
    height: 50,
    rx: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(46 11)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(49 1)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "b",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Add Friends"))), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M14.8,0C6.64,0,0,5.349,0,11.924c0,5.894,5.265,10.831,12.377,11.764.482.1,1.138.315,1.3.724a3,3,0,0,1,.048,1.329s-.174,1.037-.211,1.258c-.064.372-.3,1.453,1.282.792s8.523-4.982,11.628-8.531A10.571,10.571,0,0,0,29.6,11.924C29.6,5.349,22.961,0,14.8,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.286,0A.291.291,0,0,0,0,.295v6.61A.291.291,0,0,0,.286,7.2H1.314A.29.29,0,0,0,1.6,6.905V.295A.291.291,0,0,0,1.314,0Z",
    transform: "translate(10.4 8.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.1,0H5.017a.3.3,0,0,0-.3.295V4.222L1.634.131A.328.328,0,0,0,1.61.1l0,0L1.59.081l-.006,0L1.569.063,1.561.057,1.545.047,1.536.041,1.52.032l-.009,0L1.493.021l-.01,0L1.466.012l-.01,0L1.438,0H1.425L1.409,0H.3A.3.3,0,0,0,0,.295v6.61A.3.3,0,0,0,.3,7.2H1.383a.3.3,0,0,0,.3-.295V2.979l3.086,4.1a.3.3,0,0,0,.076.073l0,0,.019.011.009,0,.014.007.015.006.009,0,.02.007h0a.3.3,0,0,0,.077.01H6.1a.3.3,0,0,0,.3-.295V.295A.3.3,0,0,0,6.1,0",
    transform: "translate(12.8 8.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.508,5.545H1.641V.3A.294.294,0,0,0,1.348,0H.293A.294.294,0,0,0,0,.3V6.9H0a.3.3,0,0,0,.082.2l0,0,0,0a.289.289,0,0,0,.2.083H4.508A.294.294,0,0,0,4.8,6.9V5.84a.294.294,0,0,0-.292-.3",
    transform: "translate(4.8 8.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.508,1.655a.294.294,0,0,0,.292-.3V.3A.294.294,0,0,0,4.508,0H.292a.29.29,0,0,0-.2.083l0,0,0,.005A.3.3,0,0,0,0,.3H0V6.9H0a.3.3,0,0,0,.082.2l0,0,0,0a.29.29,0,0,0,.2.083H4.508A.294.294,0,0,0,4.8,6.9V5.84a.294.294,0,0,0-.292-.3H1.641V4.427H4.508a.294.294,0,0,0,.292-.3V3.068a.294.294,0,0,0-.292-.3H1.641V1.655Z",
    transform: "translate(20 8.8)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineBtn);
export default __webpack_public_path__ + "static/media/lineBtn.5e6fe938.svg";
export { ForwardRef as ReactComponent };